module.exports = __webpack_public_path__ + "static/media/1.f86a8f76.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/1.png
// module id = 1194
// module chunks = 0